var path = 'public/app/plugins/panel/heatmap/module.html';
var html = "<div class=heatmap-wrapper>\n\t<div class=heatmap-canvas-wrapper>\n\n\t\t<div class=datapoints-warning ng-if=ctrl.dataWarning>\n\t\t\t<span class=small bs-tooltip=ctrl.dataWarning.tip>{{ctrl.dataWarning.title}}</span>\n\t\t</div>\n\n\t\t<div class=heatmap-panel ng-dblclick=ctrl.zoomOut()></div>\n\t</div>\n\t<div class=heatmap-legend-wrapper ng-if=ctrl.panel.legend.show>\n\t\t<heatmap-legend></heatmap-legend>\n\t</div>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/panel/heatmap/module.html
// module id = 665
// module chunks = 5